import { findServiceData } from '../content'

export const SIMPLY_BOOK_ME = 'simplybookme'
export const MS_BOOKINGS = 'microsoftbookings'
export const CUSTOMER_FORM = 'customerform'

export const isSimplyBookMe = (store) => {
  if (!store) {
    return false
  }

  const hasNewSettings =
    store.bookingSystem != null && store.bookingSystem !== ''
  const hasOldSettings = !!store.hasSimplyBookMe

  let bookingSystem = null
  if (hasNewSettings && hasOldSettings) {
    bookingSystem = store.bookingSystem
  } else if (!hasNewSettings && hasOldSettings) {
    bookingSystem = SIMPLY_BOOK_ME
  }

  if (bookingSystem === SIMPLY_BOOK_ME) return true

  return false
}

const getStoreState = (selectedStore) => ({
  selected: selectedStore,
  bookings: {
    supported: isSimplyBookMe(selectedStore),
    none: !isSimplyBookMe(selectedStore),
  },
  meeting: {
    supported: true,
  },
})

const getStepsState = (store, service, slot, usePrepform) => ({
  meetingType: store.meeting.supported && !!store.selected,
  calendar: service?.serviceType === SIMPLY_BOOK_ME && store.bookings.supported,
  customerForm:
    (service?.serviceType === CUSTOMER_FORM || !!slot) && !!store.selected,
  prepform: service && usePrepform,
})

const wizardState = (bookingCompleted, prepCompleted, steps, usePrepform) => ({
  one: !bookingCompleted,
  two: !bookingCompleted && steps.meetingType,
  three: !bookingCompleted && steps.calendar,
  four: !bookingCompleted && steps.customerForm,
  five: !!(
    !!steps.prepform &&
    !!bookingCompleted &&
    !prepCompleted &&
    !!usePrepform
  ),
  six: bookingCompleted && (prepCompleted || !steps.prepform),
})

const wizardStage = (
  bookingCompleted, // customer form
  prepCompleted, // prepform
  homeAppointment, // special case
  usePrepform // setting in epi if to use prepform
) => [
  {
    key: 0,
    active: !bookingCompleted && !prepCompleted,
    label: 'Boka Möte',
  },
  {
    key: 1,
    active: !!(
      bookingCompleted &&
      !prepCompleted &&
      !homeAppointment &&
      usePrepform
    ),
    label: 'Inför Mötet',
  },
  {
    key: 2,
    active:
      (bookingCompleted && prepCompleted) ||
      !usePrepform ||
      (homeAppointment && bookingCompleted),
    label: 'Klart',
  },
]

const wizardChange = ({
  selectedStore,
  selectedService,
  selectedSlot,
  bookingCompleted,
  prepCompleted,
  pageContentServices,
}) => {
  const store = getStoreState(selectedStore)

  const serviceData = findServiceData(pageContentServices, selectedService)
  const usePrepform = serviceData && serviceData.usePrepform

  const stepState = getStepsState(
    store,
    selectedService,
    selectedSlot,
    usePrepform
  )

  const step = wizardState(
    bookingCompleted,
    prepCompleted,
    stepState,
    usePrepform
  )

  const stage = wizardStage(
    bookingCompleted,
    prepCompleted,
    selectedService && selectedService.id === 'home',
    usePrepform
  )

  return {
    step,
    stage,
    loading: false,
  }
}

export default wizardChange
